import { gridStoreResults } from 'fox-react/dist/components/FoxGrid/actions';
import gridNames from 'common/gridNames';
import TransportOrdersManagementSrv from './TransportOrdersManagementSrv';

export function storeResults(results) {
  return gridStoreResults(gridNames.transportOrdersManagement)(results);
}

export function getForGrid(dataState) {
  return function(dispatch) {
    return TransportOrdersManagementSrv.getForGrid(dataState).then(results => {
      dispatch(storeResults(results));
    });
  };
}

export function addAsync(model) {
  return TransportOrdersManagementSrv.add(model);
}

export function updateAsync(model) {
  return TransportOrdersManagementSrv.update(model);
}
